import React from "react"
import PropTypes from "prop-types"

import headerImage from "../images/SZITCH.jpeg"
import mainImage from "../images/SZITCH2.jpg"
import Paper from "../components/paper"

const Header = ({ siteTitle }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      padding: "4rem 1rem",
    }}
  >
    <div
      style={{
        backgroundImage: `url(${headerImage})`,
        position: "absolute",
        top: 0,
        zIndex: -5,
        height: "100vh",
        width: "100vw",
        opacity: 0.5,
      }}
    />
    <Paper>
      <h1 style={{ textAlign: "center" }}>Hey, its SZITCH </h1>
      <p style={{ textAlign: "center" }}>
        Of the gamers, by the gamers and for the gamers.
      </p>
      <div style={{ textAlign: "center" }}>
        <button onclick = "https://docs.google.com/forms/d/e/1FAIpQLSd_Irm_2yYCRihbx28znYF2i4FcvB3begjxj-ft5skaYk0o0A/viewform?usp=sf_link" target = "_blank"> Call to action </button>
      </div>
      <div style={{ margin: 60, position: "relative" }}>
        <img src={mainImage} alt="Some content" />
      </div>
    </Paper>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
